import listActions from 'src/modules/indicator/list/indicatorListActions';
import IndicatorService from 'src/modules/indicator/indicatorService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'INDICATOR_DESTROY';

const indicatorDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: indicatorDestroyActions.DESTROY_STARTED,
      });

      await IndicatorService.destroyAll([id]);

      dispatch({
        type: indicatorDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.indicator.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/indicator');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: indicatorDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: indicatorDestroyActions.DESTROY_ALL_STARTED,
      });

      await IndicatorService.destroyAll(ids);

      dispatch({
        type: indicatorDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.indicator.destroyAll.success'),
      );

      getHistory().push('/indicator');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: indicatorDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default indicatorDestroyActions;
